import React, { useEffect, useState } from "react";
import {
    Box,
    Stack,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CreateNewButton from "../commoncomponents/CreateNewButton";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import { getFacilityId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import {
    ErrorChips,
    SuccessChips,
    WarningChips,
} from "../../assets/styled-components/chips";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { useDispatch, useSelector } from "react-redux";
import ScmRepositry from "../../api/repositories/scmRepository";
import {
    updateOutsourceDetails,
    updateWorkOrderStatus,
} from "../../redux/actions/workOrderActionTypes";
import dayjs from 'dayjs';
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
import PageLoader from "../commoncomponents/PageLoader";

const ScmList = () => {
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "SCMT001");

    const currentDate = dayjs().format("DD/MM/YYYY");
    const [pageLoading, setPageLoading] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();
    const [rows, setRows] = useState([]);
    const [gridApi, setGridApi] = useState({});
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const serviceOptions = [
        { label: "FEMS", value: "FEMS", id: 1 },
        { label: "BEMS", value: "BEMS", id: 2 },
    ];

    const [service, setService] = useState(serviceOptions[0]);
    const [filterModel, setFilterModel] = useState([]);
    const [sortModel, setSortModel] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportCount, setExportCount] = useState(0)

    // Format date to ensure it displays in DD/MM/YYYY format
    const formatDateForDisplayGrid = (date) => {
        if (!date) {
            return '';  // Return empty string if no date is provided
        }

        let d;

        // Check if the date is an ISO string
        if (typeof date === 'string' && date.includes('T')) {
            d = new Date(date);
        } else {
            // Assume the date is in DD/MM/YYYY format
            const [day, month, year] = date.split('/').map(Number);
            d = new Date(year, month - 1, day);
        }

        // Validate the Date object
        if (isNaN(d.getTime())) {
            return '';  // Return empty string if the date is invalid
        }

        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const DateCellRenderer = (params) => {
        return formatDateForDisplayGrid(params.value);
    };

    const columns = [
        {
            field: "scmWorkorderno",
            headerName: "SCM Work Order No",
            width: 250,
            wrapHeaderText: false,
        },
        {
            field: "workorderno",
            headerName: "Work Order No.",
            width: 250,
            wrapHeaderText: false,
        },
        {
            field: "assetno",
            headerName: "Asset No.",
            width: 250,
            wrapHeaderText: false,
        },
        {
            field: "assetdesc",
            headerName: "Asset Description",
            width: 250,
            wrapHeaderText: false,
        },
        {
            field: "serialno",
            headerName: "Serial No",
            width: 250,
            wrapHeaderText: false,
        },
        {
            field: "targetdateFormate",
            headerName: "Work Order Date",
            width: 250,
            wrapHeaderText: false,
            cellRenderer: DateCellRenderer
        },
        {
            field: "workorderstatus",
            headerName: "Status",
            cellRenderer: (params) => {
                if (params.value === "Closed") {
                    return <SuccessChips label={params.value} />;
                }
                if (params.value === "In Progress" || params?.value === "In Progress-Outsource") {
                    return <WarningChips label={params.value} />;
                } if (params.value === "Completed" || params?.value === "Completed-Outsource") {
                    return <SuccessChips label={params.value} />;
                } else {
                    return <ErrorChips label={params.value} />;
                }
            },
            width: 250,
        },
    ];

    useEffect(() => {
        fetchScm(service);
    }, [service, pageIndex, pageSize, filterModel, sortModel]);


    const handleServiceChange = (newValue) => {
        setService(newValue);
    };



    const fetchScm = async () => {
        setRows([]);
        setIsLoading(true);
        try {

            let response1;

            if (service.value === "FEMS") {
                const serviceType = "fem";
                response1 = await ScmRepositry.scmList(serviceType,pageIndex, pageSize, filterModel, sortModel)

            } else if (service.value === "BEMS") {
                const serviceType = "bem";
                response1 = await ScmRepositry.scmList(serviceType,pageIndex, pageSize, filterModel, sortModel)
            }

            setRowCount(response1.data.totalCount);
            setExportCount(response1.data.totalCount)
            // Combine and sort the data by createddate
           

            // Format the combined and sorted data
            const formattedData = response1.data.items.map((item) => ({
                ...item,
                targetDate: utils.formatDate({
                    dateString: item.targetDate,
                    format: "dd/MM/yyyy",
                    dbdate: true,
                }),
            }));

          //  console.log('formatteddata', formattedData)

            // Set the formatted data to rows
           
            setRows(formattedData);
        } catch (error) {
            // Handle error appropriately
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchScmExport = async () => {
        setPageLoading(true);
       
        try {

            let response1;

            if (service.value === "FEMS") {
                const serviceType = "fem";
                response1 = await ScmRepositry.scmListExport(serviceType, filterModel, sortModel)

            } else if (service.value === "BEMS") {
                const serviceType = "bem";
                response1 = await ScmRepositry.scmListExport(serviceType, filterModel, sortModel)
            }


            // // Format the combined and sorted data
            // const formattedData = response1.data.items.map((item) => ({
            //     ...item,
            //     targetDate: utils.formatDate({
            //         dateString: item.targetDate,
            //         format: "dd/MM/yyyy",
            //         dbdate: true,
            //     }),
            // }));


            // Set the formatted data to rows
           
            setExportData(response1.data)
        } catch (error) {
            // Handle error appropriately
            console.error("Error fetching data", error);
        } finally {
            setPageLoading(false);
        }
    };

    const handlecreate = () => {
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: { category: 'Unscheduled' } })
        // Dynamically set title by inserting the category name
        const title = `Create Scheduled Corrective Maintenance`;

        navigate("register", { state: { title,createMode:true } });
    };

    const handleEdit = (rowData) => {
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: { assetType: serviceType } })
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
        const title = `Edit Scheduled Corrective Maintenance`;
        navigate("register", { state: { ...rowData, service: serviceType, readOnly: false, editmode: true, viewmode: false,createMode:false ,title } });
    };


    const handleView = (rowData) => {
        const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: "0" }))
        const title = `View Scheduled Corrective Maintenance`;
        navigate("register", { state: { ...rowData, service: serviceType, readOnly: false, editmode: false, viewmode: true,createMode:false,title } });
    };
    const handleRefresh = () => {
        setPageIndex(1);
        setPageSize(10);
        setFilterModel([])
        setSortModel([])
      };

    return (
        <>
         <PageLoader open={pageLoading} />
            <PageTitle title={"Scheduled Corrective Maintenance"} />
            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Box
                        mb={1}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                        }}
                    >
                        <SectionTitle
                            title={
                                "Scheduled Corrective Maintenance List"
                            }
                        />
                        <Stack direction={"row"} alignItems={"center"} gap={1}>
                            <CustomSelectInput
                                fullWidth={false}
                                labelSize={"14px"}
                                sx={{ width: 150 }}
                                label={"Service"}
                                options={serviceOptions}
                                value={service}
                                onChange={handleServiceChange}
                                placeholder={"Select Service"}
                                highlight={true}
                            />
                           {access?.canCreate && <CreateNewButton onClick={handlecreate} />}
                            <RefreshExportButtons
                               exportData={exportData}
                                refData={gridApi}
                                exportFunction={fetchScmExport}
                                handleRefresh={handleRefresh}
                                title={
                                    "Scheduled Corrective Maintenance"
                                }
                            />
                        </Stack>
                    </Box>
                    <CustomAgGrid
                        rows={rows}
                        columns={columns}
                        handleEdit={access?.canEdit && handleEdit}
                        handleView={access?.canView && handleView}
                        //handleEmail={handleEmail}
                        ref={gridApi}
                        setGridApi={setGridApi}
                        isPinnedRight={true}
                        isLoading={isLoading}
                        pagination={false}
                        setFilterModel={setFilterModel}
                        setSortModel={setSortModel}
                        totalCount={rowCount}
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        setPageIndex={setPageIndex}
                        setPageSize={setPageSize}
                    />
                </DefaultCard>
            </Box>
            <CloseButton />

        </>
    );
};

export default ScmList;
